<template lang="html">
  <v-bottom-sheet v-model="profileDetail" persistent :content-class="'showFull'">
    <v-sheet style="height: 100%">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <v-btn class="ma-2 transparent" large color="teal" icon @click="closeShowDetail()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="text-center">
              <input v-if="uploadReady" ref="fileInputImage" type="file" accept="image/x-png,image/gif,image/jpeg" class="d-none" @change="onFileInputImageChange($event)">
              <div>
                <div class="mb-1">
                  <v-avatar size="80" class="ma-auto">
                    <img :src="user.photo_xs" alt="John">
                  </v-avatar>
                </div>
                <span v-if="user.no_photo" class="primary--text font-weight-bold cursor-pointer" @click="showDialogOptions()">
                  change photo
                </span>
                <span v-else class="primary--text font-weight-bold cursor-pointer" @click="chooseImage()">
                  upload photo
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex">
              <v-text-field v-model="user.name" label="Name" @input="up" />
              <div :class="'update-button ' + showButton">
                <v-btn x-small color="primary" class="text-none" @click="changeName()">
                  Save
                </v-btn>
              </div>
            </div>
            <div class="d-flex">
              <v-text-field v-model="user.email" label="Email" readonly />
              <div class="update-button show">
                <v-btn text x-small color="primary" class="text-none" @click="goToChangeEmail()">
                  Change
                </v-btn>
              </div>
            </div>
            <div class="d-flex">
              <v-text-field v-model="user.phone" label="Phone" readonly />
              <div class="update-button show">
                <v-btn text x-small color="primary" class="text-none" @click="goToChangePhone()">
                  Change
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <a class="text-non-direction font-weight-regular primary--text" @click="goToChangePassword()">
              Change Password
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-dialog v-model="dialog.options">
      <v-card>
        <v-card-title class="headline">
          Edit Photo
        </v-card-title>
        <v-list>
          <v-list-item @click="chooseImage()">
            <v-list-item-content>
              <v-list-item-title class="primary--text">
                Change photo
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showConfirmDel()">
            <v-list-item-content>
              <v-list-item-title class="primary--text">
                Remove current photo
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.confirm_del">
      <v-card>
        <v-card-title class="headline">
          Confirm
        </v-card-title>
        <v-card-text>
          Are you sure to remove your photo?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.confirm_del = false">
            No
          </v-btn>
          <v-btn color="primary" outlined @click="deleteCurImg()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="dataError.show" multi-line top color="error" :timeout="3000">
      {{ dataError.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataError()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-bottom-sheet>
</template>

<script>
import {
  delPhoto as deletePhoto,
  changePhoto as changePhotoProfile,
  updateData as updateDataProfile
} from '@/api/customer'
export default {
  data() {
    return {
      dialog: {
        options: false,
        confirm_del: false
      },
      dataError: {
        show: false,
        message: ''
      },
      dataSuccess: {
        show: false,
        message: ''
      },
      showButton: '',
      profileDetail: false,
      user: {},
      uploadReady: true
    }
  },
  mounted() {
    this.$root.$on('ShowProfile', (dataProfile) => {
      this.profileDetail = dataProfile.show
      this.user = dataProfile.user
      this.showButton = ''
    })
  },
  methods: {
    async deleteCurImg() {
      try {
        const { data } = await deletePhoto()
        this.$store.state.loading_axios = false
        this.user = data.data
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Sukses menghapus foto profil'
      } catch (e) {
        this.dataError.show = true
        this.dataError.message = e.string
      }
      this.dialog.confirm_del = false
    },
    showConfirmDel() {
      this.dialog.options = false
      this.dialog.confirm_del = true
    },
    showDialogOptions() {
      this.dialog.options = true
    },
    closeShowDetail() {
      this.profileDetail = !this.profileDetail
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
    },
    goToChangePassword() {
      const dataProfile = {
        show: false,
        user: {}
      }
      this.$root.$emit('ShowProfile', dataProfile)
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.$router.push({ name: 'change_password' }).catch(() => {})
    },
    goToChangeEmail() {
      const dataProfile = {
        show: false,
        user: {}
      }
      this.$root.$emit('ShowProfile', dataProfile)
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.$router.push({ name: 'change_email' }).catch(() => {})
    },
    goToChangePhone() {
      const dataProfile = {
        show: false,
        user: {}
      }
      this.$root.$emit('ShowProfile', dataProfile)
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.$router.push({ name: 'change_phone' }).catch(() => {})
    },
    up() {
      this.showButton = 'show'
    },
    chooseImage() {
      this.dialog.options = false
      this.$refs.fileInputImage.click()
    },
    async onFileInputImageChange(e) {
      const form = new FormData()
      form.append('file', e.target.files[0])

      const headers = {
        'Content-Type': 'multipart/form-data'
      }
      try {
        const { data } = await changePhotoProfile(form, headers)
        this.$store.state.loading_axios = false
        this.user = data.data
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Sukses mengganti foto profil'
      } catch (e) {
        this.dataError.show = true
        this.dataError.message = e.string
      }
      this.resetInputImage()
    },
    resetInputImage() {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    closeDataError() {
      this.dataError.show = false
    },
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    async changeName() {
      try {
        await updateDataProfile(this.user)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Sukses mengganti nama'
        const closeMenu = {
          show: false,
          permanent: false
        }
        setTimeout(() => this.$root.$emit('ShowMenu', closeMenu), 3000)
      } catch (e) {
        this.dataError.show = true
        this.dataError.message = e.string
      }
    }
  }
}
</script>
